module.exports = __webpack_public_path__ + "static/img/hungry.52036ea.png";